import React from 'react';

import { Path, Svg } from './styles';
import { IconProps } from './types';

const path = [
  'M7 6.41667C5.54167 6.41667 4.30208 6.18819 3.28125 5.73125C2.26042 5.27431',
  '1.75 4.725 1.75 4.08333C1.75 3.44167 2.26042 2.89236 3.28125 2.43542C4.30208',
  '1.97847 5.54167 1.75 7 1.75C8.45833 1.75 9.69792 1.97847 10.7188 2.43542C11.7396',
  '2.89236 12.25 3.44167 12.25 4.08333C12.25 4.725 11.7396 5.27431 10.7188 5.73125C9.69792',
  '6.18819 8.45833 6.41667 7 6.41667ZM7 9.33333C5.54167 9.33333 4.30208 9.10486 3.28125',
  '8.64792C2.26042 8.19097 1.75 7.64167 1.75 7V5.54167C1.75 5.96944 1.94931 6.33169 2.34792',
  '6.62842C2.74653 6.92475 3.22292 7.16528 3.77708 7.35C4.33125 7.53472 4.90739 7.66831 5.5055',
  '7.75075C6.10322 7.83358 6.60139 7.875 7 7.875C7.39861 7.875 7.89678 7.83358 8.4945 7.75075C9.09261',
  '7.66831 9.66875 7.53472 10.2229 7.35C10.7771 7.16528 11.2535 6.92475 11.6521 6.62842C12.0507 6.33169',
  '12.25 5.96944 12.25 5.54167V7C12.25 7.64167 11.7396 8.19097 10.7188 8.64792C9.69792 9.10486 8.45833',
  '9.33333 7 9.33333ZM7 12.25C5.54167 12.25 4.30208 12.0215 3.28125 11.5646C2.26042 11.1076 1.75 10.5583',
  '1.75 9.91667V8.45833C1.75 8.88611 1.94931 9.24836 2.34792 9.54508C2.74653 9.84142 3.22292 10.0819 3.77708',
  '10.2667C4.33125 10.4514 4.90739 10.5852 5.5055 10.668C6.10322 10.7504 6.60139 10.7917 7 10.7917C7.39861',
  '10.7917 7.89678 10.7504 8.4945 10.668C9.09261 10.5852 9.66875 10.4514 10.2229 10.2667C10.7771 10.0819 11.2535',
  '9.84142 11.6521 9.54508C12.0507 9.24836 12.25 8.88611 12.25 8.45833V9.91667C12.25 10.5583 11.7396 11.1076',
  '10.7188 11.5646C9.69792 12.0215 8.45833 12.25 7 12.25Z',
].join(' ');

export const IconDataBase = ({ width = 14, height = 14, color, className }: IconProps) => (
  <Svg className={className} width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <Path d={path} fill={color || 'currentColor'} />
  </Svg>
);

export default IconDataBase;
